// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ImageEditor__container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.ImageEditor__actionBar {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 2px;\n}\n\n.ImageEditor__title {\n  border-bottom: 1px solid #ccc;\n  margin-bottom: 18px;\n  padding: 20px 24px 18px;\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
